import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=3084b2b1&scoped=true"
import script from "./projectInfo.vue?vue&type=script&lang=js"
export * from "./projectInfo.vue?vue&type=script&lang=js"
import style0 from "./projectInfo.vue?vue&type=style&index=0&id=3084b2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084b2b1",
  null
  
)

export default component.exports